const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
/* Discovery Set - offer box: open the Klaviyo signup form (VfDUU6) in-page
   instead of navigating away. Klaviyo's onsite JS is already loaded sitewide. */
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.klaviyo-signup-trigger');
  if (!trigger) return;
  e.preventDefault();
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'VfDUU6']);
});